import React from "react";
import UploadIcon from "@assets/images/NoSubscriptionAstronot.png";
import { Link } from "react-router-dom";
const URL_TO_NAVIGATE = process.env.REACT_APP_WORDPRESS_URL;
const NoSubscription = () => {
  return (
    <div
      className={`p-2 bg-white max-h-[587px] h-screen rounded-[12px] flex flex-col justify-center items-center`}
    >
       <img
          src={UploadIcon}
          className="border-[1px] border-solid border-white rounded-[50%] p-1 "
          alt={"Upload icon"}
        />
      <h2 className="text-[24px] font-[700] text-[#303030] text-center font-Lato">
        Looks Like You Haven’t Subscribed Yet
      </h2>
      <p className="text-[#6C6C6C] text-[16px] font-[Lato] text-center my-2 max-w-[80%]">
        Subscribe now to unlock your personalized dashboard, workout plans, and exclusive insights.
      </p>
      <Link
        to={`${URL_TO_NAVIGATE}/checkout/`}
        className="px-[18px] py-[10px] bg-[#64DDFF] text-white rounded-[32px] flex items-center justify-center gap-2 disabled:opacity-50"
        //   disabled={uploading}
      >
        {/* <img
          src={UploadIcon}
          className="border-[1px] border-solid border-white rounded-[50%] p-1 "
          alt={"Upload icon"}
        /> */}
        Subscribe now
      </Link>
    </div>
  );
};

export default NoSubscription;
